"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateContactDocMapDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
class CreateContactDocMapDto {
}
exports.CreateContactDocMapDto = CreateContactDocMapDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)({ message: "Contact ID is optional." }),
    (0, class_validator_1.IsInt)({ message: "Contact ID should be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDocMapDto.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Document id is required." }),
    (0, class_validator_1.IsInt)({ message: "Document id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDocMapDto.prototype, "documentId", void 0);
